import { generateUseContext } from '@guiker/react-context'

import { AuthenticationContext } from './AuthenticationContext'

export const useAuthenticationContext = generateUseContext(AuthenticationContext)
